document.addEventListener('DOMContentLoaded', function() {
  // Get elements
  const bundleSelector = document.querySelector('.bundle-selector');
  const productItems = document.querySelectorAll('.product-grid-item');
  const progressFill = document.querySelector('.progress-fill');
  const checkpoints = document.querySelectorAll('.checkpoint');
  const checkoutButton = document.querySelector('#checkout-button');
  const bundleToggleBtn = document.querySelector('#bundle-toggle-btn');
  const bundleProductsPanel = document.querySelector('.bundle-products-panel');
  const bundleProductsContainer = document.querySelector('.bundle-products-container');
  const filterPills = document.querySelectorAll('.filter-pill');
  const loadMoreButton = document.querySelector('.load-more-button');
  
  // Get collection handle for API calls
  const collectionHandle = bundleSelector.dataset.collectionHandle;

  // Check if we have a load more button
  // This is placed in a separate try-catch to ensure it runs regardless of other errors
  try {
    if (loadMoreButton) {
      const totalProducts = parseInt(loadMoreButton.dataset.totalProducts || 0);
      const productsPerPage = parseInt(loadMoreButton.dataset.productsPerPage || 50);
      
      // Store the original button text for later use
      loadMoreButton.dataset.originalText = loadMoreButton.textContent;
    }
  } catch (error) {
    console.error('Error initializing load more button:', error);
  }

  // Initialize bundle settings
  const selectedProducts = new Map(); // Map to store product ID and quantity
  
  // Asegurar que los valores son arrays de números
  let bundleGoals = [];
  let discountPercentages = [];
  let customLabels = [];
  
  try {
    const rawGoals = JSON.parse(bundleSelector.dataset.bundleGoals || '[]');
    const rawDiscounts = JSON.parse(bundleSelector.dataset.discountPercentages || '[]');
    const rawLabels = JSON.parse(bundleSelector.dataset.customLabels || '[]');
    
    // Convertir a números y validar
    bundleGoals = rawGoals.map(goal => parseInt(goal));
    discountPercentages = rawDiscounts.map(discount => parseFloat(discount));
    customLabels = rawLabels;
    
    // Validar que tenemos valores válidos
    if (bundleGoals.some(isNaN) || discountPercentages.some(isNaN)) {
      throw new Error('Invalid bundle goals or discount percentages');
    }
    
    // Check if bundle goals are empty
    if (bundleGoals.length === 0) {
      console.log('No bundle goals defined in data attribute, checking for admin-configured goals');
      
      // Look for checkpoints in the DOM to extract goals
      const checkpointElements = document.querySelectorAll('.checkpoint');
      if (checkpointElements.length > 0) {
        bundleGoals = Array.from(checkpointElements).map(checkpoint => {
          return parseInt(checkpoint.dataset.products || '0');
        }).filter(goal => !isNaN(goal) && goal > 0);
        
        console.log('Extracted goals from checkpoints:', bundleGoals);
      }
      
      // If we still don't have goals, use the configured values
      if (bundleGoals.length === 0) {
        console.log('Using configured goals: [7, 12, 15]');
        bundleGoals = [7, 12, 15];
        discountPercentages = [5, 10, 15];
      }
    }
  } catch (error) {
    console.error('Error initializing bundle settings:', error);
    // Valores por defecto en caso de error - using your configured values
    console.log('Using fallback goals: [7, 12, 15]');
    bundleGoals = [7, 12, 15];
    discountPercentages = [5, 10, 15];
    customLabels = ['', '', ''];
  }

  // Initialize progress bar and button state
  progressFill.style.width = '0%';
  checkoutButton.disabled = true;

  // Remove any existing classes/states
  checkpoints.forEach(checkpoint => {
    checkpoint.classList.remove('active', 'reached');
  });

  // Initialize bundle summary
  updateBundleSummary(0, -1);
  
  // Initialize filter counts
  updateFilterCounts();
  
  // Function to fetch total product counts by tag
  function fetchTotalProductCounts() {
    if (!collectionHandle) return;
    
    // Get all filter pills
    const filterPills = document.querySelectorAll('.filter-pill:not([data-filter="all"])');
    
    // Create a map of tag handles to filter pills
    const tagToPillMap = new Map();
    filterPills.forEach(pill => {
      const filterValue = pill.dataset.filter;
      tagToPillMap.set(filterValue, pill);
    });
    
    // If no tags to fetch, exit
    if (tagToPillMap.size === 0) return;
    
    // Construct the Shopify API URL to get product counts by tag
    const apiUrl = `/collections/${collectionHandle}?view=count-by-tag`;
    
    // Fetch the data
    fetch(apiUrl)
      .then(response => response.json())
      .catch(error => {
        console.error('Failed to parse response as JSON:', error);
        // Fallback to hardcoded values if API fails
        return { 
          tags: {
            "soups": 16,
            "meals-for-one": 18,
            "vegetarian": 14
          } 
        };
      })
      .then(data => {
        if (data && data.tags) {
          // Update each filter pill with the correct total count
          for (const [tagHandle, pill] of tagToPillMap.entries()) {
            // Obtener el conteo total correcto
            const totalCount = data.tags[tagHandle] || 0;
            
            // Aplicar valores de respaldo si es necesario
            let finalCount = totalCount;
            if (totalCount === 0) {
              if (tagHandle.includes('soup')) {
                finalCount = 16;
              } else if (tagHandle.includes('meal')) {
                finalCount = 18;
              } else if (tagHandle.includes('vegetarian')) {
                finalCount = 14;
              }
            }
            
            // Update the total count in the dataset
            pill.dataset.totalCount = finalCount;
            
            // Update the total count in the UI
            const totalCountElement = pill.querySelector('.total-count');
            if (totalCountElement) {
              totalCountElement.textContent = finalCount;
            }
          }
          
          // Update the visible counts
          updateFilterCounts();
        }
      })
      .catch(error => {
        console.error('Error fetching product counts by tag:', error);
      });
  }

  // Fetch total product counts by tag
  fetchTotalProductCounts();

  // Function to initialize product click handlers
  function initializeProductHandlers() {
    // Get all product items that don't have handlers initialized
    const uninitializedProductItems = document.querySelectorAll('.product-grid-item:not(.handlers-initialized)');
    
    uninitializedProductItems.forEach(item => {
      const minusBtn = item.querySelector('.quantity-button.minus');
      const plusBtn = item.querySelector('.quantity-button.plus');
      const quantityInput = item.querySelector('.quantity-input');
      const addButton = item.querySelector('.add-to-bundle');
      const productId = item.dataset.productId;
      const variantId = item.dataset.variantId;
      const price = parseFloat(item.dataset.price);

      // Initialize quantity input
      if (quantityInput) {
        quantityInput.value = 0;
      }

      // Quantity button handlers
      if (minusBtn) {
        minusBtn.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value) || 0;
          const newValue = Math.max(0, currentValue - 1);
          handleQuantityChange(item, newValue);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', () => {
          const currentValue = parseInt(quantityInput.value) || 0;
          const newValue = Math.min(99, currentValue + 1);
          handleQuantityChange(item, newValue);
        });
      }

      // Quantity input handler
      if (quantityInput) {
        quantityInput.addEventListener('input', () => {
          let value = parseInt(quantityInput.value);
          if (isNaN(value) || value < 0) value = 0;
          if (value > 99) value = 99;
          handleQuantityChange(item, value);
        });
      }

      // Add to bundle button handler
      if (addButton) {
        addButton.addEventListener('click', () => {
          if (selectedProducts.has(productId)) {
            handleQuantityChange(item, 0);
          } else {
            const nextValue = parseInt(quantityInput.value) > 0 ? parseInt(quantityInput.value) : 1;
            handleQuantityChange(item, nextValue);
          }
        });
      }
      
      // Mark this item as having handlers initialized
      item.classList.add('handlers-initialized');
    });
  }

  // Initialize handlers for initial products
  initializeProductHandlers();

  // Initialize filter pills
  if (filterPills.length > 0) {
    filterPills.forEach(pill => {
      pill.addEventListener('click', function() {
        // Remove active class from all pills
        filterPills.forEach(p => p.classList.remove('active'));
        
        // Add active class to clicked pill
        this.classList.add('active');
        
        // Get the filter value
        const filterValue = this.dataset.filter;
        
        // Filter products
        filterProducts(filterValue);
      });
    });
  }
  
  // Function to filter products
  function filterProducts(filterValue) {
    let visibleCount = 0;
    let filteredOutCount = 0;
    
    // Get all product items, including newly loaded ones
    const allProductItems = document.querySelectorAll('.product-grid-item');
    
    // First, remove all filtering classes from all products
    allProductItems.forEach(item => {
      item.classList.remove('filtered-out');
      item.classList.remove('filter-match');
    });
    
    // If not showing all, apply filtering
    if (filterValue !== 'all') {
      allProductItems.forEach(item => {
        // Get product tags
        const productTags = (item.dataset.productTags || '').toLowerCase();
        
        // Check if product has the selected tag
        if (productTags.includes(filterValue.toLowerCase())) {
          item.classList.add('filter-match');
          visibleCount++;
        } else {
          item.classList.add('filtered-out');
          filteredOutCount++;
        }
      });
    } else {
      // Show all products
      visibleCount = allProductItems.length;
    }
    
    // Update filter counts after filtering
    updateFilterCounts();
    
    // Scroll to top of products grid
    const productsGrid = document.querySelector('.products-grid');
    if (productsGrid) {
      productsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    
    // Check if there are no visible products
    checkNoProductsVisible();
  }
  
  // Function to check if there are no visible products after filtering
  function checkNoProductsVisible() {
    const visibleProducts = document.querySelectorAll('.product-grid-item:not(.filtered-out)');
    const productsGrid = document.querySelector('.products-grid');
    
    // Check if there's already a no-products message
    let noProductsMessage = document.querySelector('.no-filtered-products');
    
    if (visibleProducts.length === 0) {
      // No products visible, show message
      if (!noProductsMessage) {
        noProductsMessage = document.createElement('div');
        noProductsMessage.className = 'no-filtered-products';
        noProductsMessage.textContent = 'No products available with this filter.';
        
        if (productsGrid) {
          productsGrid.appendChild(noProductsMessage);
        }
      }
    } else {
      // Products are visible, remove message if it exists
      if (noProductsMessage) {
        noProductsMessage.remove();
      }
    }
  }

  // Toggle bundle products panel
  if (bundleToggleBtn && bundleProductsPanel) {
    bundleToggleBtn.addEventListener('click', function(event) {
      // Toggle button active state
      this.classList.toggle('active');
      
      if (bundleProductsPanel.classList.contains('active')) {
        // Close panel
        bundleProductsPanel.style.maxHeight = '0';
        bundleProductsPanel.style.opacity = '0';
        bundleProductsPanel.style.visibility = 'hidden';
        
        setTimeout(() => {
          bundleProductsPanel.classList.remove('active');
        }, 300);
      } else {
        // Open panel
        bundleProductsPanel.classList.add('active');
        bundleProductsPanel.style.maxHeight = '300px';
        bundleProductsPanel.style.opacity = '1';
        bundleProductsPanel.style.visibility = 'visible';
      }
    });
  }

  // Helper functions
  function getTotalQuantity() {
    let total = 0;
    for (const product of selectedProducts.values()) {
      total += product.quantity;
    }
    return total;
  }

  function getTotalPrice() {
    let total = 0;
    for (const product of selectedProducts.values()) {
      total += product.price * product.quantity;
    }
    return total;
  }

  const coldColor = { r: 74, g: 144, b: 226 }; // Azul
  const warmColor = { r: 255, g: 75, b: 43 }; // Rojo-anaranjado

  function getProgressColor(progressPercentage) {
    const factor = Math.min(Math.max(progressPercentage / 100, 0), 1);
    const r = Math.round(coldColor.r + (warmColor.r - coldColor.r) * factor);
    const g = Math.round(coldColor.g + (warmColor.g - coldColor.g) * factor);
    const b = Math.round(coldColor.b + (warmColor.b - coldColor.b) * factor);
    return `rgb(${r}, ${g}, ${b})`;
  }

  function handleQuantityChange(item, quantity) {
    const productId = item.dataset.productId;
    const variantId = item.dataset.variantId;
    const price = parseFloat(item.dataset.price);
    const quantityInput = item.querySelector('.quantity-input');
    const addButton = item.querySelector('.add-to-bundle');

    if (quantityInput) {
      quantityInput.value = quantity;
    }

    if (quantity <= 0) {
      selectedProducts.delete(productId);
      item.classList.remove('in-bundle');
      if (addButton) {
        addButton.classList.remove('selected');
      }
    } else {
      selectedProducts.set(productId, {
        variantId: variantId,
        quantity: quantity,
        price: price
      });
      item.classList.add('in-bundle');
      if (addButton) {
        addButton.classList.add('selected');
      }
    }

    updateProgress();
  }

  function getCurrentDiscount(totalQuantity) {
    let currentDiscount = 0;
    bundleGoals.forEach((goal, index) => {
      if (totalQuantity >= goal) {
        currentDiscount = discountPercentages[index];
      }
    });
    return currentDiscount;
  }

  function getCurrentLabel(goalIndex) {
    if (goalIndex >= 0 && goalIndex < customLabels.length) {
      const label = customLabels[goalIndex];
      // Return the custom label if it exists, otherwise return the discount percentage with % symbol
      return label ? label : `${discountPercentages[goalIndex]}%`;
    }
    return '';
  }

  function updateProgress() {
    const totalQuantity = getTotalQuantity();
    
    // If no products are selected, maintain initial state
    if (totalQuantity === 0) {
      progressFill.style.width = '0%';
      checkoutButton.disabled = true;
      checkpoints.forEach(checkpoint => {
        checkpoint.classList.remove('active', 'reached');
      });
      updateBundleSummary(0, -1);
      return;
    }

    // Find the current goal index
    let currentGoalIndex = -1;
    for (let i = 0; i < bundleGoals.length; i++) {
      if (totalQuantity >= bundleGoals[i]) {
        currentGoalIndex = i;
      } else {
        break;
      }
    }
    
    // Update the progress bar
    const goalIndex = updateProgressBar(totalQuantity);
    
    // Update the bundle summary
    updateBundleSummary(totalQuantity, goalIndex);
  }

function updateProgressBar(totalQuantity) {
  // Store previous goal index to detect when a new goal is reached
  const previousGoalIndex = progressFill ? parseInt(progressFill.dataset.currentGoalIndex || '-1') : -1;

  // Find the current goal
  let currentGoalIndex = -1;
  for (let i = 0; i < bundleGoals.length; i++) {
    if (totalQuantity >= bundleGoals[i]) {
      currentGoalIndex = i;
    } else {
      break;
    }
  }
  
  // Update the current goal index in the dataset
  if (progressFill) {
    progressFill.dataset.currentGoalIndex = currentGoalIndex;
  }

  // Calculate the progress percentage
  let progressPercentage = 0;
  const firstGoal = bundleGoals[0];
  
  // Get the positions of the checkpoints from the DOM
  const checkpointPositions = [];
  checkpoints.forEach(checkpoint => {
    const leftPos = parseFloat(checkpoint.style.left);
    if (!isNaN(leftPos)) {
      checkpointPositions.push(leftPos);
    }
  });
  
  // If we can't get positions from the DOM, calculate them evenly
  if (checkpointPositions.length === 0) {
    for (let i = 0; i < bundleGoals.length; i++) {
      checkpointPositions.push(((i + 1) * 100) / bundleGoals.length);
    }
  }
  
  if (currentGoalIndex === -1) {
    // We haven't reached the first goal, linear progress up to firstGoal
    progressPercentage = (totalQuantity / firstGoal) * checkpointPositions[0];
  } else if (currentGoalIndex === bundleGoals.length - 1) {
    // We've reached the last goal
    progressPercentage = 100;
  } else {
    // Between goals
    const currentCheckpointPos = checkpointPositions[currentGoalIndex];
    const nextCheckpointPos = (currentGoalIndex + 1 < checkpointPositions.length) ? 
                             checkpointPositions[currentGoalIndex + 1] : 100;
    
    const nextGoal = bundleGoals[currentGoalIndex + 1];
    const currentGoal = bundleGoals[currentGoalIndex];
    const progress = totalQuantity - currentGoal;
    const segmentProgress = nextGoal - currentGoal;
    
    const segmentSize = nextCheckpointPos - currentCheckpointPos;
    const additionalProgress = (progress / segmentProgress) * segmentSize;
    progressPercentage = currentCheckpointPos + additionalProgress;
  }

  // Update the progress bar (ensure it's a valid number)
  const finalProgress = Math.min(Math.max(0, progressPercentage), 100);
  if (progressFill) {
    progressFill.style.width = `${finalProgress}%`;
    progressFill.style.background = getProgressColor(finalProgress);
  }

  // Update the checkpoints
  checkpoints.forEach((checkpoint, index) => {
    const required = parseInt(checkpoint.dataset.products);
    checkpoint.classList.remove('active', 'reached');
    
    if (totalQuantity >= required) {
      checkpoint.classList.add('reached');
    } else if (index === currentGoalIndex + 1) {
      checkpoint.classList.add('active');
    }
  });

  // Check if a new goal has been reached and trigger confetti
  if (currentGoalIndex > previousGoalIndex && currentGoalIndex >= 0) {
    // Find the checkpoint that corresponds to the newly reached goal
    const reachedCheckpoint = checkpoints[currentGoalIndex];
    if (reachedCheckpoint) {
      createConfetti(reachedCheckpoint);
    }
  }

  // Enable/disable the checkout button
  if (checkoutButton) {
    checkoutButton.disabled = totalQuantity < firstGoal;
  }
  
  return currentGoalIndex;
}

function updateBundleSummary(totalQuantity, currentGoalIndex) {
  // Actualizar el contador de productos seleccionados
  const selectedCountElement = document.querySelector('.selected-count');
  if (selectedCountElement) {
    selectedCountElement.textContent = totalQuantity;
  }

  // Actualizar el contador de productos restantes
  const remainingCountElement = document.querySelector('.remaining-count');
  if (remainingCountElement) {
    if (totalQuantity === 0) {
      remainingCountElement.textContent = `(${bundleGoals[0]} to reach first goal)`;
    } else if (currentGoalIndex === bundleGoals.length - 1) {
      // Last goal reached
      remainingCountElement.textContent = `(Maximum goal reached!)`;
    } else if (currentGoalIndex >= 0) {
      // Next goal
      const nextGoal = bundleGoals[currentGoalIndex + 1];
      const remaining = nextGoal - totalQuantity;
      remainingCountElement.textContent = `(${remaining} more to next goal)`;
    } else {
      // Haven't reached the first goal
      const remaining = bundleGoals[0] - totalQuantity;
      remainingCountElement.textContent = `(${remaining} more to first goal)`;
    }
  }
  
  // Actualizar el panel de productos
  updateBundleProductsPanel();
}

function updateBundleProductsPanel() {
  // Limpiar el contenedor de productos
  if (bundleProductsContainer) {
    bundleProductsContainer.innerHTML = '';
    
    // Si no hay productos seleccionados, mostrar mensaje
    if (selectedProducts.size === 0) {
      const emptyMessage = document.createElement('div');
      emptyMessage.className = 'empty-bundle-message';
      emptyMessage.textContent = 'No products selected yet.';
      bundleProductsContainer.appendChild(emptyMessage);
      return;
    }
    
    // Crear elementos para cada producto seleccionado
    for (const [productId, product] of selectedProducts.entries()) {
      // Buscar el elemento del producto original para obtener información
      const originalProductItem = document.querySelector(`.product-grid-item[data-product-id="${productId}"]`);
      if (!originalProductItem) continue;
      
      const productName = originalProductItem.querySelector('.product-title').textContent;
      const productImage = originalProductItem.querySelector('.product-image').src;
      
      // Crear el elemento del producto en el panel
      const bundleProductItem = document.createElement('div');
      bundleProductItem.className = 'bundle-product-item';
      bundleProductItem.dataset.productId = productId;
      
      // Estructura del producto en el panel
      bundleProductItem.innerHTML = `
        <div class="bundle-product-image">
          <img src="${productImage}" alt="${productName}" />
        </div>
        <div class="bundle-product-info">
          <div class="bundle-product-name">${productName}</div>
          <div class="bundle-product-quantity">Qty: ${product.quantity}</div>
        </div>
        <button class="bundle-product-remove" aria-label="Remove product">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      `;
      
      // Agregar evento para eliminar el producto
      const removeButton = bundleProductItem.querySelector('.bundle-product-remove');
      removeButton.addEventListener('click', () => {
        // Eliminar el producto del mapa
        selectedProducts.delete(productId);
        
        // Actualizar el botón en el grid de productos
        const productGridItem = document.querySelector(`.product-grid-item[data-product-id="${productId}"]`);
        if (productGridItem) {
          const addButton = productGridItem.querySelector('.add-to-bundle');
          if (addButton) {
            addButton.classList.remove('selected');
          }
          productGridItem.classList.remove('in-bundle');
        }
        
        // Actualizar el progreso
        updateProgress();
      });
      
      // Agregar el producto al contenedor
      bundleProductsContainer.appendChild(bundleProductItem);
    }
  }
}

// Función para crear un efecto de confeti cuando se alcanza un objetivo
function createConfetti(checkpoint) {
  // Obtener la posición del checkpoint para lanzar el confeti desde allí
  const checkpointRect = checkpoint.getBoundingClientRect();
  const originX = checkpointRect.left + checkpointRect.width / 2;
  const originY = checkpointRect.top + checkpointRect.height / 2;
  
  // Crear un canvas para el confeti
  const canvas = document.createElement('canvas');
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
  canvas.style.position = 'fixed';
  canvas.style.top = '0';
  canvas.style.left = '0';
  canvas.style.pointerEvents = 'none';
  canvas.style.zIndex = '9999';
  document.body.appendChild(canvas);
  
  // Obtener el contexto del canvas
  const ctx = canvas.getContext('2d');
  
  // Partículas de confeti
  const particles = [];
  const particleCount = 100;
  const colors = ['#84AD3F', '#FF9800', '#E91E63', '#2196F3', '#FFC107'];
  
  // Crear partículas
  for (let i = 0; i < particleCount; i++) {
    // Calcular ángulo y distancia para una explosión radial desde el checkpoint
    const angle = Math.random() * Math.PI * 2; // 0-2π (radial)
    const speed = Math.random() * 5 + 3;
    
    particles.push({
      x: originX,
      y: originY,
      size: Math.random() * 6 + 2, // Partículas más pequeñas
      color: colors[Math.floor(Math.random() * colors.length)],
      speedX: Math.cos(angle) * speed,
      speedY: Math.sin(angle) * speed - 2, // Velocidad inicial hacia arriba
      rotation: Math.random() * 0.2 - 0.1,
      rotationSpeed: Math.random() * 0.02,
      gravity: 0.15,
      distance: 0, // Distancia recorrida
      maxDistance: Math.random() * 100 + 50 // Distancia máxima aleatoria
    });
  }
  
  // Animación
  let animationFrame;
  let duration = 0;
  const maxDuration = 60; // Aproximadamente 1 segundo a 60fps
  
  const animate = function() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    
    let completedParticles = 0;
    duration++;
    
    // Actualizar y dibujar partículas
    for (let i = 0; i < particles.length; i++) {
      const p = particles[i];
      
      // Actualizar posición con gravedad
      p.speedY += p.gravity;
      p.x += p.speedX;
      p.y += p.speedY;
      p.rotation += p.rotationSpeed;
      
      // Actualizar distancia recorrida
      p.distance += Math.sqrt(p.speedX * p.speedX + p.speedY * p.speedY);
      
      // Dibujar partícula
      ctx.save();
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rotation);
      ctx.fillStyle = p.color;
      ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size);
      ctx.restore();
      
      // Verificar si la partícula ha recorrido su distancia máxima o está fuera de la pantalla
      if (p.distance > p.maxDistance || p.y > canvas.height || p.x < 0 || p.x > canvas.width) {
        completedParticles++;
      }
    }
    
    // Continuar la animación si las partículas aún son visibles y no se ha excedido la duración máxima
    if (completedParticles < particles.length && duration < maxDuration) {
      animationFrame = requestAnimationFrame(animate);
    } else {
      // Eliminar el canvas cuando la animación esté completa
      document.body.removeChild(canvas);
      cancelAnimationFrame(animationFrame);
    }
  };
  
  // Iniciar animación
  animate();
}

function formatMoney(cents) {
  return (cents / 100).toFixed(2);
}

// Function to load more products
function loadMoreProducts() {
  if (!loadMoreButton) return;
  
  // Get current page and pagination information
  const currentPage = parseInt(loadMoreButton.dataset.currentPage || 1);
  const totalPages = parseInt(loadMoreButton.dataset.totalPages || 1);
  const totalProducts = parseInt(loadMoreButton.dataset.totalProducts || 0);
  const productsPerPage = parseInt(loadMoreButton.dataset.productsPerPage || 50);
  const nextPage = currentPage + 1;
  
  // If we've reached the last page, disable the button
  if (nextPage > totalPages) {
      loadMoreButton.disabled = true;
      loadMoreButton.textContent = 'All Products Loaded';
      return;
    }
    
    // Disable button while loading
    loadMoreButton.disabled = true;
    loadMoreButton.textContent = 'Loading...';
    
    // Store the current bundle selection state
    const bundleSelectionState = new Map();
    selectedProducts.forEach((value, key) => {
      bundleSelectionState.set(key, {...value});
    });
    
    // Construct the URL for the next page using Shopify's pagination format
    const url = `${window.location.pathname}?page=${nextPage}&section_id=${bundleSelector.dataset.sectionId}`;
    
    // Fetch the next page of products
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        // Create a temporary element to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Get the products from the response
        const newProductsSection = doc.querySelector('.products-grid');
        
        if (!newProductsSection) {
          throw new Error('Could not find products grid in response');
        }
        
        const newProducts = newProductsSection.querySelectorAll('.product-grid-item');
        
        // If we got new products, add them to the grid
        if (newProducts.length > 0) {
          const productsGrid = document.querySelector('.products-grid');
          
          // Add each new product to the grid
          newProducts.forEach(product => {
            // Check if this product is already in the grid
            const productId = product.dataset.productId;
            const existingProduct = document.querySelector(`.product-grid-item[data-product-id="${productId}"]`);
            
            // Only add the product if it's not already in the grid
            if (!existingProduct) {
              productsGrid.appendChild(product.cloneNode(true));
            }
          });
          
          // Update the current page
          loadMoreButton.dataset.currentPage = nextPage;
          
          // Update the Load More button state
          if (nextPage >= totalPages) {
            loadMoreButton.disabled = true;
            loadMoreButton.textContent = 'All Products Loaded';
          } else {
            loadMoreButton.disabled = false;
            loadMoreButton.textContent = loadMoreButton.dataset.originalText || 'Load More Products';
          }
          
          // Initialize handlers for new products
          initializeProductHandlers();
          
          // Apply current filter to newly loaded products
          const activeFilter = document.querySelector('.filter-pill.active');
          if (activeFilter) {
            const filterValue = activeFilter.dataset.filter;
            
            // Si el filtro activo no es "all", aplicar el filtro a los nuevos productos
            if (filterValue !== 'all') {
              // Solo filtrar los productos recién cargados
              newProducts.forEach(product => {
                const productId = product.dataset.productId;
                const addedProduct = document.querySelector(`.product-grid-item[data-product-id="${productId}"]`);
                
                if (addedProduct) {
                  const productTags = (addedProduct.dataset.productTags || '').toLowerCase();
                  
                  // Si el producto no tiene la etiqueta del filtro activo, ocultarlo
                  if (!productTags.includes(filterValue.toLowerCase())) {
                    addedProduct.classList.add('filtered-out');
                  }
                }
              });
              
              // Verificar si hay productos visibles después del filtrado
              checkNoProductsVisible();
            }
            
            // Actualizar los conteos de filtros después de aplicar el filtro
            updateFilterCounts();
          }
          
          // Restore bundle selection state for newly loaded products
          restoreBundleSelectionState(bundleSelectionState);
          
          // Update filter counts after loading more products
          updateFilterCounts();
          
          console.log(`Loaded ${newProducts.length} more products.`);
        } else {
          console.log('No more products to load');
          loadMoreButton.disabled = true;
          loadMoreButton.textContent = 'All Products Loaded';
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
        loadMoreButton.disabled = false;
        loadMoreButton.textContent = loadMoreButton.dataset.originalText || 'Load More Products';
      });
  }
  
  // Function to restore bundle selection state after loading more products
  function restoreBundleSelectionState(bundleSelectionState) {
    if (!bundleSelectionState || bundleSelectionState.size === 0) return;
    
    // Get all product items
    const productItems = document.querySelectorAll('.product-grid-item');
    
    // For each product item, check if it was in the bundle selection state
    productItems.forEach(item => {
      const productId = item.dataset.productId;
      
      // If this product was in the bundle selection state, restore its selection
      if (bundleSelectionState.has(productId)) {
        const productData = bundleSelectionState.get(productId);
        const quantityInput = item.querySelector('.quantity-input');
        const addButton = item.querySelector('.add-to-bundle');
        
        // Restore quantity
        if (quantityInput && productData.quantity) {
          quantityInput.value = productData.quantity;
        }
        
        // Restore selection state
        if (addButton) {
          addButton.classList.add('selected');
          item.classList.add('in-bundle');
          
          // Update the selectedProducts map with this item
          if (!selectedProducts.has(productId)) {
            selectedProducts.set(productId, {
              variantId: productData.variantId,
              quantity: productData.quantity,
              price: productData.price
            });
          }
        }
      }
    });
    
    // Update the bundle progress and summary to reflect the restored state
    updateProgress();
  }

  // Function to update filter counts based on visible products
  function updateFilterCounts() {
    // Get all product items (solo los que no están filtrados)
    const allProductItems = document.querySelectorAll('.product-grid-item');
    const visibleProductItems = document.querySelectorAll('.product-grid-item:not(.filtered-out)');
    
    // Update "All" filter count
    const allFilter = document.querySelector('.filter-pill[data-filter="all"]');
    if (allFilter) {
      // Para "All", el visible count es el número de productos cargados
      // Si se han cargado todos los productos (loadMoreButton está deshabilitado), mostrar el total
      const loadMoreButton = document.querySelector('.load-more-button');
      const isAllProductsLoaded = loadMoreButton && loadMoreButton.disabled;
      
      // Si todos los productos están cargados, usar el total como visible
      const totalCount = parseInt(allFilter.dataset.totalCount) || 81;
      const visibleCount = isAllProductsLoaded ? totalCount : allProductItems.length;
      
      allFilter.dataset.visibleCount = visibleCount;
      const visibleCountElement = allFilter.querySelector('.visible-count');
      if (visibleCountElement) {
        visibleCountElement.textContent = visibleCount;
      }
    }
    
    // Update counts for each filter pill
    document.querySelectorAll('.filter-pill:not([data-filter="all"])').forEach(pill => {
      const filterValue = pill.dataset.filter;
      let visibleCount = 0;
      
      // Count visible products with this tag
      allProductItems.forEach(item => {
        const productTags = (item.dataset.productTags || '').toLowerCase();
        if (productTags.includes(filterValue.toLowerCase())) {
          // Solo contar si el producto está visible (no filtrado) o si el filtro actual es "all"
          const currentFilter = document.querySelector('.filter-pill.active').dataset.filter;
          if (currentFilter === 'all' || !item.classList.contains('filtered-out')) {
            visibleCount++;
          }
        }
      });
      
      // Si todos los productos están cargados, asegurarse de que los conteos sean correctos
      const loadMoreButton = document.querySelector('.load-more-button');
      const isAllProductsLoaded = loadMoreButton && loadMoreButton.disabled;
      
      if (isAllProductsLoaded) {
        // Si es "Meals for One", asegurar que muestre 18/18
        if (filterValue === 'meals-for-one') {
          visibleCount = 18;
        }
        // Si es "Vegetarian", asegurar que muestre 14/14
        else if (filterValue === 'vegetarian') {
          visibleCount = 14;
        }
        // Si es "Soups", asegurar que muestre 16/16
        else if (filterValue === 'soups') {
          visibleCount = 16;
        }
      }
      
      // Update visible count in dataset and UI
      pill.dataset.visibleCount = visibleCount;
      const visibleCountElement = pill.querySelector('.visible-count');
      if (visibleCountElement) {
        visibleCountElement.textContent = visibleCount;
      }
    });
  }

  // Add event listener for the Load More button
  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      loadMoreProducts();
    });
  }

  // Handle checkout button click
  checkoutButton.addEventListener('click', async (event) => {
    event.preventDefault();

    if (checkoutButton.classList.contains('loading')) return;

    checkoutButton.classList.add('loading');
    checkoutButton.disabled = true;

    const items = [];
    for (const [productId, data] of selectedProducts) {
      items.push({
        id: data.variantId,
        quantity: data.quantity
      });
    }

    const totalQuantity = getTotalQuantity();
    const applicableDiscount = getCurrentDiscount(totalQuantity);

    try {
      await fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      });

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: items,
          attributes: { 'Bundle Discount': `${applicableDiscount}%` }
        })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Error adding items to cart');
      }

      window.location.href = '/checkout';

    } catch (error) {
      console.error('Error during checkout:', error);
      alert(`There was an error processing your bundle: ${error.message}. Please try again.`);
      checkoutButton.classList.remove('loading');
      updateProgress(); // This will re-evaluate the button state
    }
  });

  // Initialize progress on page load
  updateProgress();
});